module.exports = __webpack_public_path__ + "images/psp/psplinkscard/10x15.svg";